import { environment } from './environments/environment';

export class Config {
  public static serverUrl = environment.apiPath;
  public static gtagToken = environment.production ? 'UA-127500702-2' : 'UA-127500702-1';
}
